import _createClass from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Electronic Codebook block mode.
 */
import { BlockCipherMode } from './cipher-core.js';
export var ECB = /*#__PURE__*/function (_BlockCipherMode) {
  _inherits(ECB, _BlockCipherMode);

  var _super = _createSuper(ECB);

  function ECB() {
    _classCallCheck(this, ECB);

    return _super.apply(this, arguments);
  }

  return _createClass(ECB);
}(BlockCipherMode);

ECB.Encryptor = /*#__PURE__*/function (_ECB) {
  _inherits(_class, _ECB);

  var _super2 = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super2.apply(this, arguments);
  }

  _createClass(_class, [{
    key: "processBlock",
    value: function processBlock(words, offset) {
      this._cipher.encryptBlock(words, offset);
    }
  }]);

  return _class;
}(ECB);

ECB.Decryptor = /*#__PURE__*/function (_ECB2) {
  _inherits(_class2, _ECB2);

  var _super3 = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super3.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "processBlock",
    value: function processBlock(words, offset) {
      this._cipher.decryptBlock(words, offset);
    }
  }]);

  return _class2;
}(ECB);